<template>
  <div>
    <section class="section">
      <h2>{{ keepInTouch.title }}</h2>
      <v-container>
      <v-row>
        <v-col 
        :cols="$vuetify.breakpoint.smAndDown ? 12 : 3">
          <div class="d-flex justify-center align-center" >
            <div>
              <v-img
                height="300"
                :src="keepInTouch.pictureUrl"
                :lazy-src="keepInTouch.pictureLazyUrl"
              ></v-img>
            </div>
          </div>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 2">
        </v-col>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 7" >
          <div
          class="d-flex flex-column justify-space-between" style="height:100%">
            <p v-html="keepInTouch.description"></p>
            <div v-if="!contactSent" class="contactForm">
              <div class="d-flex justify-space-around align-center">
                <v-text-field class="pa-3" label="Adresse e-mail*" type="email" v-model="contact.email" outlined required hide-details></v-text-field>
                <v-btn class="pa-3" rounded depressed color="#ef6758" style="color:white" @click="send" :loading="wip" :disabled="wip">
                  Envoyer
                </v-btn>
              </div>
            </div>
            <div v-else>
              <v-alert
                outlined
                type="success"
              >
                Votre inscription a été reçue avec succès.
              </v-alert>
            </div>

            <v-alert
              v-if="hasError"
              class="my-3"
              outlined
              type="error"
            >
              Inscription impossible. Réessayez ultérieurement.
            </v-alert>
          </div>
        </v-col>
      </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    wip: false,
    hasError: false,
    contactSent: false,
    contact: {
      name: '',
      email: '',
      comment: ''
    }
  }),
  computed: {
    ...mapGetters('strapiv2', ['keepInTouch'])
  },
  methods: {
    send () {
      this.hasError = false
      if (!this.contact.email) {
        return
      }
      this.wip = true
      this.contact.name = this.contact.email.split('@')[0]
      this.contact.comment = '[keep in touch]'
      axios.post('/sky/web/contact', this.contact)
        .then(() => {
          this.contactSent = true
        })
        .catch(() => {
          this.hasError = true
        })
        .finally(() => {
          this.wip = false
        })
    },
  }
}
</script>

<style scoped>
.contactForm {
  background-color: white;
  padding: 1em;
  border-radius: 30px;
  border: 1px solid black;
}
</style>